import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {buildTeammateDisplayName} from '../../../../../helpers/modelHelpers';
import {TeammateAvatar} from '../../../../common/avatars/teammateAvatar';
import {NotificationCellBase, NotificationCellBasePublicProps} from './notificationCellBase';

/*
 * Props.
 */

interface CommentNotificationCellProps extends NotificationCellBasePublicProps {}

/*
 * Style.
 */

const StyledNameSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const CommentNotificationCell: FC<CommentNotificationCellProps> = (props) => (
  <NotificationCellBase {...props} icon={renderIcon(props)} title={renderTitle(props)}>
    {props.notification.summary}
  </NotificationCellBase>
);

function renderIcon(props: CommentNotificationCellProps) {
  const {fromTeammate} = props.notification;
  if (!fromTeammate) {
    return null;
  }

  return <TeammateAvatar teammate={fromTeammate} size={VisualSizesEnum.SMALL} />;
}

function renderTitle(props: CommentNotificationCellProps) {
  const {fromTeammate} = props.notification;
  if (!fromTeammate) {
    return <Trans id="nc-comment-generic">A comment was posted</Trans>;
  }

  return (
    <Trans id="nc-comment-teammate">
      <StyledNameSpan>{buildTeammateDisplayName(fromTeammate)}</StyledNameSpan> commented
    </Trans>
  );
}
